<script>
import FeaturePlaceholder from './FeaturePlaceholder.vue';
import NoChatDark from 'dashboard/assets/images/no-chat-dark.svg';
import NoChatLight from 'dashboard/assets/images/no-chat.svg';

export default {
  components: { FeaturePlaceholder },
  props: {
    message: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      NoChatDark,
      NoChatLight,
    };
  },
};
</script>

<template>
  <div class="flex flex-col items-center justify-center h-full">
    <img
      class="m-4 w-32 hidden dark:block"
      :src="NoChatDark"
      alt="No Chat dark"
    />
    <img class="m-4 w-32 block dark:hidden" :src="NoChatLight" alt="No Chat" />
    <span class="text-sm text-n-slate-12 font-medium text-center">
      {{ message }}
      <br />
    </span>
    <!-- Cmd bar, keyboard shortcuts placeholder -->
    <FeaturePlaceholder />
  </div>
</template>
